/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons";
import { IMAGE_URL_v4 } from "../../../../envs/prod/constants";
import { teamDetails } from "../../../../utils/constants/Team";

export default function TeamOurTeamSection({ windowSize }) {
  const [seemore, setSeemore] = useState(windowSize >= 768 ? false : true);
  const [seemoreToggle, setSeemoreToggle] = useState(
    windowSize >= 768 ? false : true
  );

  useEffect(() => {
    setSeemore(windowSize >= 768 ? false : true);
    setSeemoreToggle(windowSize >= 768 ? true : false);
  }, [windowSize]);
  const texts = seemoreToggle ? teamDetails : teamDetails.slice(0, 6);

  return (
    <div className={styles.teams_member_wrapper}>
      <div className={styles.team_title}>
        <h2>
          Meet the <span>team</span>
        </h2>
      </div>
      <div className={styles.team_member_list} id={`scrollposition`}>
        {texts?.map((data, id) => (
          <div
            key={data.title}
            className={styles.card_img_value}
            style={{ paddingTop: data.designation == "" && 10 }}
          >
            {data.designation !== "" ? (
              <img
                alt="seekho"
                className={`${styles.card_content_img} ${
                  id > 22 ? "shadow-md drop-shadow-lg rounded-2xl" : ""
                }`}
                src={data.img}
              />
            ) : (
              <a
                href="https://apply.workable.com/seekho/"
                target="_blank"
                style={{ textDecoration: "none" }}
              >
                <img
                  alt="seekho"
                  className={styles.card_content_img}
                  src={data.img}
                />
              </a>
            )}
            <div className={styles.card_title}>{data.title}</div>
            <div className={styles.card_designation}>
              {data.designation !== "" ? (
                data.designation
              ) : (
                <a
                  className={styles.join_now}
                  href="https://apply.workable.com/seekho/"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  Join now
                </a>
              )}
            </div>
            {data.designation !== "" && (
              <div className={styles.card_social}>
                {data?.linkedin !== "" && (
                  <a href={data.linkedin} target="_blank">
                    <FontAwesomeIcon
                      color="#0A66C2"
                      icon={faLinkedin}
                      className={styles.icon_social}
                    />
                  </a>
                )}
                {data?.twitter !== "" && (
                  <a href={data.twitter} target="_blank">
                    <FontAwesomeIcon
                      color="#1DA1F2"
                      icon={faTwitterSquare}
                      className={styles.icon_social}
                    />
                  </a>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className={styles.view_more_wrapper}>
        {seemore == true && (
          <span
            className={styles.see_all}
            onClick={() => {
              setSeemoreToggle(!seemoreToggle);
              seemoreToggle &&
                document
                  .querySelector("#scrollposition")
                  .scrollIntoView({ behavior: "smooth" });
            }}
          >
            {seemoreToggle ? "View less" : "View all"}{" "}
          </span>
        )}
      </div>
    </div>
  );
}
